import { Actions } from '../../actions';
import parseError from './parseError';


export function ssoTokenReducer(state={}, action) {
    switch (action.type) {
        case Actions.decryptSsoToken:
            return {
                ...state,
                loading: true,
                error: "",
            }
        case Actions.decryptSsoTokenSuccess:
            const decryptSsoTokenSuccessError = parseError(action);
            if (decryptSsoTokenSuccessError) {
                return {
                    ...state,
                    loading: false,
                    error: decryptSsoTokenSuccessError || "Failed to decrypt SSO token",
                }
            }

            return {
                ...state,
                loading: false,
                error: "",
                account: action.payload.data.account,
                authConfigOnlineAuthCode: action.payload.data.authConfigOnlineAuthCode,
                authConfigOfflineAuthCode: action.payload.data.authConfigOfflineAuthCode,
            }
        case Actions.decryptSsoTokenFail:
            return {
                ...state,
                loading: false,
                error: "Failed to decrypt SSO token",
            }
        default:
            return state
    }
}

export default ssoTokenReducer